module.exports = __webpack_public_path__ + "static/media/ModalImage1.3faf796d.png";